import styled from 'styled-components'

export const FooterSection = styled.section``

export const LinksDiv = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.4);
  height: max-content;
  padding: 10px;
  @media screen and (min-width: 600px) and (max-width: 780px) {
    padding: 10px 80px;
  }
  @media screen and (min-width: 780px) {
    padding: 10px 120px;
  }
`

export const RedirectLink = styled.a`
  text-decoration: none;
  color: var(--text);
  font-size: 12px;
  font-weight: 600;
  padding: 10px;

  &:hover {
    text-decoration: underline;
  }
`
export const SocialIcons = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: space-around;
  padding: 0px 16px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.4);
`
export const CopyrightInfo = styled.div`
  text-align: center;
  height: 48px;
  color: var(--text);
  background-color: rgba(255, 255, 255, 0.2);

  p {
    font-size: 12px;
    line-height: 48px;
    color: var(--text);
  }
`
